// -----------------------------------------------------------------------------
// Scripts for certificates
// -----------------------------------------------------------------------------

$(function () {
  
  lightbox.option({
    'fitImagesInViewport': true,
    'disableScrolling': true,
    'fadeDuration': 300
  });

});